export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal.',
		"url" : 'https://www.facebook.com/share/v/1AhoX74prF/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/rutast310326.jpg',
	   "funcion": 'Rutas de la Transformación.',
		"url" : 'https://www.facebook.com/share/v/1AFxZXUW8Z/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/CA310326.jpg',
	   "funcion": 'Contraloría en Acción.',
		"url" : 'https://www.facebook.com/share/v/18Cox3MyM2/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]